var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceFreeze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36316 28.5835C6.56904 30.2965 8.08554 31.768 9.83399 32.9218M22.224 35.3552C21.1622 35.5634 20.0827 35.6678 19.0007 35.6668M19.0007 35.6668C17.8973 35.6668 16.8198 35.5593 15.7765 35.3552M19.0007 35.6668V25.6668M35.2923 22.536C35.7875 20.2294 35.7923 17.8445 35.3065 15.536M32.6382 9.41683C31.4323 7.70387 29.9158 6.23232 28.1673 5.0785M15.7965 2.64183C16.8521 2.43591 17.9252 2.33266 19.0007 2.3335M19.0007 2.3335C20.0965 2.3335 21.1673 2.43933 22.2048 2.64183M19.0007 2.3335V12.3335M5.36316 9.41683C6.56904 7.70387 8.08554 6.23232 9.83399 5.0785M32.7507 28.4118C31.5448 30.1248 30.0283 31.5964 28.2798 32.7502M12.334 19.0002H2.33399M2.33399 19.0002C2.33295 17.836 2.45389 16.675 2.69482 15.536M2.33399 19.0002C2.33399 20.1877 2.45899 21.3468 2.69482 22.4643M7.33399 30.6668L14.2865 23.7143M30.6673 30.6668L23.7148 23.7143M25.6673 19.0002H35.6673M30.6673 7.3335L23.7148 14.286M7.33399 7.3335L14.2865 14.286",
    stroke: "#418DF0",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0007 25.6668C20.7688 25.6668 22.4645 24.9645 23.7147 23.7142C24.9649 22.464 25.6673 20.7683 25.6673 19.0002C25.6673 17.2321 24.9649 15.5364 23.7147 14.2861C22.4645 13.0359 20.7688 12.3335 19.0007 12.3335C17.2325 12.3335 15.5368 13.0359 14.2866 14.2861C13.0364 15.5364 12.334 17.2321 12.334 19.0002C12.334 20.7683 13.0364 22.464 14.2866 23.7142C15.5368 24.9645 17.2325 25.6668 19.0007 25.6668Z",
    fill: "#418DF0",
    stroke: "#418DF0",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceFreeze);
export default __webpack_public_path__ + "static/media/AttendanceFreeze.60204fdee5487547fb7aa7f3b30be194.svg";
export { ForwardRef as ReactComponent };